const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Workshops Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('WorkshopInstances', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  return $resource(appConfiguration.apiUrl + '/learn/v3/workshop-instances/:subresource/:group/:subsubresource', null, {
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    getWithGcal: {params: {subresource: 'gcal'}, method: 'GET', isArray: false},
    getZoomHistory: {params: {subresource: 'zoom-history'}, method: 'GET', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    createOccurrence: {params: {subresource: 'occurrence'}, method: 'POST', isArray: false},
    updatePostUUID: {params: {subresource: 'post-uuid'}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    groupRemoval: {params: {subresource: '', group: 'group', subsubresource: ''}, method: 'DELETE', isArray: false},
    fullDelete: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);